<m-tooltip [content]="tooltip" position="top">
  <p-inputSwitch
    class="{{ size === 'small' ? 'm-switch small' : 'm-switch' }}"
    [style]="style"
    [styleClass]="styleClass"
    [ngClass]="{
      toggle: isToggle,
      small: size === 'small',
      'is-disabled': disabled,
      'no-permission': !permissionAllowed,
    }"
    [formControl]="switchFormControl"
    [name]="name"
    [tabindex]="tabindex"
    [ariaLabel]="ariaLabel"
    [ariaLabelledBy]="ariaLabelledBy"
    [disabled]="disabled"
    [trueValue]="trueValue"
    [falseValue]="falseValue"
    [readonly]="readonly"
    (onChange)="onChange.emit($event); onSwitchToggle($event)"
    [inputId]="inputId">
  </p-inputSwitch>
</m-tooltip>
